import { Directive, effect, inject, input } from '@angular/core';
import { Select } from 'primeng/select';

@Directive({
  selector: '[appPrimengSelect]',
  standalone: true,
})
export class PrimengSelectDirective {
  private readonly select = inject(Select);

  /* prettier-ignore */
  public readonly emptyMessage = input<typeof this.select.emptyMessage>('Brak danych do wyświetlenia.');
  public readonly showClear = input<typeof this.select.showClear>(true);

  public constructor() {
    effect(() => this.configureDefaultNotResultFoundLabel());
    effect(() => this.configureShowClear());
  }

  private configureShowClear(): void {
    this.select.showClear = this.showClear();
  }

  private configureDefaultNotResultFoundLabel(): void {
    this.select.emptyMessage = this.emptyMessage();
  }
}
